// app/javascript/lib/intl_format.js
// Client-side counterpart of AreaUnit + CurrencyConverter display logic.
// Canonical data over the wire is always m² + cents/ISO-currency;
// Intl.NumberFormat handles digits, separators, and symbol placement for
// every locale (including Arabic-Indic numerals under ar).

const locale = () => document.documentElement.lang || "en"

const SQM_PER = {
  sqm: 1, hectare: 10_000, sqkm: 1_000_000, acre: 4046.8564224,
  dunam: 1000, feddan: 4200.833, rai: 1600, mu: 666.6667
}

const UNIT_SUFFIX = {
  sqm: "m²", hectare: "ha", sqkm: "km²", acre: "ac",
  dunam: "dunam", feddan: "feddan", rai: "rai", mu: "mu"
}

// Auto-pick like AreaUnit.auto_unit: m² < 1 ha ≤ hectare < 1,000 ha ≤ km²
export function formatArea(sqm, unit = "auto") {
  if (sqm == null) return "–"
  if (unit === "auto") {
    unit = sqm < 10_000 ? "sqm" : sqm >= 10_000_000 ? "sqkm" : "hectare"
  }
  const value = sqm / SQM_PER[unit]
  const digits = unit === "sqm" ? 0 : value < 10 ? 2 : 1
  const n = new Intl.NumberFormat(locale(), { maximumFractionDigits: digits }).format(value)
  return `${n} ${UNIT_SUFFIX[unit]}`
}

export function formatMoney(cents, currency) {
  if (cents == null || !currency) return "–"
  return new Intl.NumberFormat(locale(), {
    style: "currency",
    currency,
    maximumFractionDigits: 0
  }).format(cents / 100)
}

// "SAR 1,200 / ha / month" — mirrors LocalizationHelper#rent_rate_line
export function formatRentRate(props) {
  if (props.rent_amount_cents == null) return null
  const basis  = props.rent_basis === "whole_parcel" ? "" : " / ha"
  const period = { per_day: "day", per_week: "week", per_month: "month", per_year: "year" }[props.rent_period] || props.rent_period
  return `${formatMoney(props.rent_amount_cents, props.currency)}${basis} / ${period}`
}
